import sessionData from '../Component/UI/Session/getSession';

const NoAuth = ()=> {
    return sessionData('sessionData') && localStorage.getItem('isUserDeviceInfoVarified') === 'true'
        ? true
        : false;

};
export default NoAuth;
